import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Constants from '../../config/constants';
import { COLUMN_STYLE, getColumnStyle } from '../datatable/util';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import SearchBar from '../datatable/SearchBar';
import DataTable from '../datatable/DataTable';
import EnvelopCreateModal from '../../modal/envelop/EnvelopCreateModal';
import EnvelopEditModal from '../../modal/envelop/EnvelopEditModal';
import EnvelopDuplicateModal from '../../modal/duplicate/EnvelopDuplicateModal';
import Alert from '../../modal/alert/Alert';

import { defaultRejectHandler, getErrorValue, withDefaultSort } from '../../utils/utility';

import {
  listEnvelop,
  deleteEnvelop,
  clearErrorEnvelop,
} from '../../redux/envelop/envelop_actions';

class EnvelopDataTable extends React.Component {
  constructor(props) {
    super(props);

    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const decimalColumn = getColumnStyle(COLUMN_STYLE.decimal);
    const float2 = getColumnStyle(COLUMN_STYLE.float2);
    const { t } = props;

    this.columns = [
      {
        id: 'name',
        Header: () => <b>{t('name')}</b>,
        accessor: item => ({ name: item.name, id: item.id, type: item.type.toLowerCase() }),
        Cell: row => <Link to={`/envelops/${row.value.id}/${row.value.type}`}>{row.value.name}</Link>,
        ...textColumn,
      },
      {
        Header: () => <b>{t('type')}</b>,
        accessor: 'type',
        ...textColumn,
      },
      {
        Header: () => <b>{t('azimuth angle')}</b>,
        accessor: 'azimuth_angle',
        ...decimalColumn,
      },
      {
        Header: () => <b>{t('inclination')}</b>,
        accessor: 'inclination',
        ...decimalColumn,
      },
      {
        Header: () => <b>{t('zone')}</b>,
        accessor: 'zone_name',
        ...textColumn,
      },
      {
        Header: () => <b>{t('WWR')}</b>,
        accessor: 'WWR',
        ...float2,
      },
      {
        Header: () => <b>{t('Total Area')}</b>,
        accessor: 'area',
        ...float2,
      },
    ];

    this.state = {
      categoryOption: 'all',
      isShowCreateModal: false,
      isShowEditModal: false,
      isShowDeleteModal: false,
      isDuplicateModal: false,
      isCreated: false,
      isEdited: false,
      isDuplicated: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isCreating && nextProps.isCreating !== this.props.isCreating && !nextProps.errorMessage) {
      this.setState({ isShowCreateModal: false, isCreated: true });
    }

    if (this.props.isEditing && nextProps.isEditing !== this.props.isEditing && !nextProps.errorMessage) {
      this.setState({ isShowEditModal: false, isEdited: true });
    }

    if (this.props.isDeleting && nextProps.isDeleting !== this.props.isDeleting && !nextProps.errorMessage) {
      this.setState({ isShowDeleteModal: false });
    }

    if (this.props.isDuplicating && nextProps.isDuplicating !== this.props.isDuplicating && !nextProps.errorMessage) {
      this.setState({ isShowDuplicateModal: false, isDuplicated: true });
    }
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;

    this.props.listEnvelop(
      this.search.pageSize,
      this.search.page,
      withDefaultSort(this.search.sorted),
      this.search.filtered,
      {
        all: null,
        public: true,
        private: false,
      }[category],
    );

    this.setState({ categoryOption: category });
  }

  dismissCreateModal() {
    this.props.clearError();
    this.setState({ isShowCreateModal: false });
  }

  dismissEditModal() {
    this.props.clearError();
    this.setState({ isShowEditModal: false });
  }

  dismissDeleteModal() {
    this.props.clearError();
    this.setState({ isShowDeleteModal: false });
  }

  dismissDuplicateModal() {
    this.props.clearError();
    this.setState({ isShowDuplicateModal: false });
  }

  render() {
    const {
      selectedInstance: item,
      isShowCreateModal,
      isShowEditModal,
      isShowDeleteModal,
      isShowDuplicateModal,
    } = this.state;

    const {
      filteredCount,
      isLoading,
      isDeleting,
      building,
      errorMessage,
      t,
    } = this.props;

    return (
      <div>
        <EnvelopCreateModal
          show={isShowCreateModal}
          isCreated={this.state.isCreated}
          onHide={() => this.dismissCreateModal()}
          building={building}
        />
        <EnvelopEditModal
          envelop={item}
          show={isShowEditModal}
          isEdited={this.state.isEdited}
          onHide={() => this.dismissEditModal()}
          building={building}
        />
        <EnvelopDuplicateModal
          item={item}
          show={isShowDuplicateModal}
          title={t('copy envelop')}
          label={t('new envelop name')}
          isDuplicated={this.state.isDuplicated}
          onHide={() => this.dismissDuplicateModal()}
        />
        <Alert
          show={isShowDeleteModal}
          onHide={() => !isDeleting && this.dismissDeleteModal()}
          title={t('delete envelop')}
          body={`${t('do you want to delete')} ${item ? item.name : ''}?`}
          errorMessage={getErrorValue(errorMessage, 'detail')}
          primaryButtonTitle={isDeleting ? t('deleting') : t('delete')}
          primaryButtonStyle={'danger'}
          primaryButtonEnabled={!isDeleting}
          onPrimaryButtonClick={() => this.props.deleteEnvelop(item)}
        />
        <SearchBar
          onSearch={text => this.updateSortFilter(text, null, this.state.categoryOption)}
          auxiliaryButton={<Button bsStyle="success" onClick={() => this.setState({ isShowCreateModal: true, isCreated: false })}>{t('create')}</Button>}
        />
        <DataTable
          columns={this.columns}
          data={this.props.envelop}
          onActionEdit={item => this.setState({ isShowEditModal: true, selectedInstance: item.original, isEdited: false })}
          onActionDuplicate={item => this.setState({ isShowDuplicateModal: true, selectedInstance: item.original, isDuplicated: false })}
          onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedInstance: item.original })}
          filteredCount={filteredCount}
          isLoading={isLoading}
          onFetchData={state => this.updateSortFilter(this.search.filtered, state, this.state.categoryOption)}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  envelop: state.envelop.orderedIds.map(id => state.envelop.objects[id]),
  filteredCount: state.envelop.filteredCount,
  isLoading: state.envelop.isLoading,
  isCreating: state.envelop.isCreating,
  isEditing: state.envelop.isEditing,
  isDeleting: state.envelop.isDeleting,
  isDuplicating: state.envelop.isDuplicating,
  errorMessage: state.envelop.errorMessage,
});

const mapDispatchToProps = (dispatch, props) => ({
  listEnvelop: (pageSize, page, sorted, filtered, isPublic) =>
    defaultRejectHandler(
      dispatch(listEnvelop(pageSize, page, sorted, filtered, isPublic, props.building.id))
    ),
  deleteEnvelop: ({ id }) => defaultRejectHandler(dispatch(deleteEnvelop(id))),
  clearError: () => dispatch(clearErrorEnvelop()),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(EnvelopDataTable),
);



// WEBPACK FOOTER //
// ./src/components/envelop/EnvelopDataTable.js